import { render, staticRenderFns } from "./KategoriCampaign.vue?vue&type=template&id=3dcde9da&scoped=true"
import script from "./KategoriCampaign.vue?vue&type=script&lang=js"
export * from "./KategoriCampaign.vue?vue&type=script&lang=js"
import style0 from "./KategoriCampaign.vue?vue&type=style&index=0&id=3dcde9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcde9da",
  null
  
)

export default component.exports